<template>
  <div class="change-data-wrapper">
    <el-table :data="data" border style="width: 100%" header-row-class-name="headerTable"
      :cell-style="{ padding: '8px 0' }">
      <el-table-column prop="type" label="分析要求类型" align="center" width="120">
        <template slot-scope="scope">
          <el-tag type="primary" size="small">{{ getTypeName(scope.row.type) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="rawAmount" label="变更前金额" align="center">
        <template slot-scope="scope">
          <div class="change-value-cell">
            <span v-if="scope.row.rawAmount" :class="{'value-changed': String(scope.row.rawAmount) !== String(scope.row.changeAmount)}">
              {{ scope.row.rawAmount }}
            </span>
            <el-tag v-else type="info" size="small">NA</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="changeAmount" label="变更后金额" align="center">
        <template slot-scope="scope">
          <div class="change-value-cell">
            <span v-if="scope.row.changeAmount" :class="{'value-changed': String(scope.row.rawAmount) !== String(scope.row.changeAmount)}">
              {{ scope.row.changeAmount }}
            </span>
            <el-tag v-else type="info" size="small">NA</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="rawFile" label="变更前附件" align="center" width="150">
        <template slot-scope="scope">
          <div class="file-btn-group" v-if="scope.row.rawFile">
            <el-button size="mini" type="primary" icon="el-icon-download" plain
              @click="download(oldData.id, scope.row.type, 'old')">下载</el-button>
            <el-button size="mini" type="primary" icon="el-icon-view" plain
              @click="preview(oldData.id, scope.row.type, 'old')">预览</el-button>
          </div>
          <el-tag v-else type="info" size="small">NA</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="changeFile" label="变更后附件" align="center" width="150">
        <template slot-scope="scope">
          <div class="file-btn-group" v-if="scope.row.changeFile">
            <el-button size="mini" type="primary" icon="el-icon-download" plain
              @click="download(newData.id, scope.row.type, 'new')">下载</el-button>
            <el-button size="mini" type="primary" icon="el-icon-view" plain
              @click="preview(newData.id, scope.row.type, 'new')">预览</el-button>
          </div>
          <el-tag v-else type="info" size="small">NA</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <file-preview v-if="showFile" :show-dialog="showFile" :response="fileInfo" @submit="close"></file-preview>
  </div>
</template>

<script>

import {attachmentContract} from "@/api/dilivery/sales/contract";
import {attachmentDownload} from "@/api/dilivery/audit";
import FilePreview from "@/components/file/FilePreview.vue";
import { getDataInLocalStorage } from "@/utils/localStorage";
const baseURL = process.env.VUE_APP_BASE_API

export default {
  name: "AnalysisChangeData",
  components: {FilePreview},
  props: {
    showDialog: {
      default: true
    },
    oldData:{
      default:()=>([])
    },
    newData:{
      default:()=>([])
    }
  },
  data(){
    return{
      data:[],
      table:[],
      showFile:false,
      fileInfo:null,
      TypeOption: [
        {label: 'SENIOR_ANALYSIS', name: 'seniorAnalysisAnnex',value:'高级分析'},
        {label: 'CUSTOMIZED_ANALYSIS', name: 'customizedAnalysisAnnex',value: '个性化分析'},
      ],
    }
  },
  mounted() {
    this.getAnalysisData()
  },
  methods: {
    getTypeName(type) {
      const found = this.TypeOption.find(item => item.label === type);
      return found ? found.value : type;
    },
    async download(id, type, status) {
      try {
        let annex;
        switch (type) {
          case 'SENIOR_ANALYSIS':
            annex = 'SENIOR_ANALYSIS_ANNEX'
            break
          case 'CUSTOMIZED_ANALYSIS':
            annex = 'CUSTOMIZED_ANALYSIS_ANNEX'
            break
          default:
            break
        }
        let downloadURL
        if (status === 'oldData') {
          downloadURL = '/sequencing-contract/attachment/'
        } else {
          downloadURL = '/audit-info/attachment/'
        }
        let url = `${baseURL}${downloadURL}${id}/${annex}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    async preview(id, type, status) {
      try {
        let annex;
        switch (type) {
          case 'SENIOR_ANALYSIS':
            annex = 'SENIOR_ANALYSIS_ANNEX'
            break
          case 'CUSTOMIZED_ANALYSIS':
            annex = 'CUSTOMIZED_ANALYSIS_ANNEX'
            break
          default:
            break
        }
        if(status === 'oldData'){
          this.fileInfo = await attachmentContract(id, annex)
        }else{
          this.fileInfo = await attachmentDownload(id, annex)
        }
        this.showFile = true
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.showFile = false
    },
    getAnalysisData() {
      try {
        const arr1 = {...this.oldData}
        const arr2 = {...this.newData}
        const typeList1 = Object.keys(arr1.moreAnalysisRequest)
        const typeList2 = Object.keys(arr2.moreAnalysisRequest)
        const typeList = new Set([...typeList1,...typeList2])

        for(let type of typeList){
          let item = {
            type:type,
            rawAmount:arr1.moreAnalysisRequest[type]?arr1.moreAnalysisRequest[type]:'',
            changeAmount:arr2.moreAnalysisRequest[type]?arr2.moreAnalysisRequest[type]:'',
            rawFile:arr1[this.TypeOption.find(item => item.label === type).name],
            changeFile:arr2[this.TypeOption.find(item => item.label === type).name],
          }
          this.data.push(item)
        }
      }catch (error) {
        console.log(error);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.change-data-wrapper {
  ::v-deep .headerTable th {
    background-color: #f5f7fa;
    font-weight: 600;
    color: #303133;
  }
}

.change-value-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 24px;
}

.value-changed {
  color: #f56c6c;
  font-weight: 500;
}

.file-btn-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
}
</style>
